import StyledPage from "./styles";

const Page = (props) => {
  const { children } = props;

  return <StyledPage {...props}>{children}</StyledPage>;
};

export default Page;
